<template lang="pug">
.filters
	h5 Filter Results By:
	.filters__inner
		.filters__dropdowns.blue-form
			.filters__filter(v-for="(filter, fIndex) in filters", :key="filter.label")
				label.filters__label {{ filter.label }}
				.filters__select-custom.empty(:title="filter.placeholder")
					select(@change="addFilterTag($event, fIndex)")
						option 
						option(v-for="option in filter.options", :key="option") {{ option }}
		.filters__controls
			button.filters__apply.btn(@click="applyFilters") Apply
			button.filters__clear(@click="clearFilters($event)") Clear All
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
	name: 'Filters',
	props: {},
	data() {
		return {
			filters: null,
			filterTagArray: []
		}
	},
	computed: {
		...mapGetters(["listingsData"]),
	},
	methods: {
		...mapActions(["setFilterTags", "setFilteredListings"]),
		addFilterTag(e, i) {
			let selectParent = e.target.closest(".filters__select-custom");
			if (e.target.value !== "") {
				selectParent.classList.remove("empty");
			} else {
				selectParent.classList.add("empty");
			}
			this.filterTagArray[i] = e.target.value;
		},
		applyFilters() {
			let tagValues = [];
			for (let i = 0; i < this.filterTagArray.length; i++) {
				if (this.filterTagArray[i] && this.filterTagArray[i] !== "") {
					tagValues.push(this.filterTagArray[i]);
				}
			}
			this.setFilterTags(tagValues);
			this.setFilteredListings();
		},
		clearFilters(e) {
			let listingParent = e.target.closest(".listing-app");
			let selectInputs = [...listingParent.querySelectorAll(".filters__dropdowns select")];
			selectInputs.forEach(select => {
				let selectParent = select.closest(".filters__select-custom");
				select.value = "";
				selectParent.classList.add("empty");
			});
			this.filterTagArray = [];
			this.setFilterTags([]);
			this.setFilteredListings();
		}
	},
	mounted() {
		this.filters = this.listingsData.filters;
	}
}
</script>

<style scoped lang="scss">
.filters {
	display: flex;
	flex-direction: column;
	padding-bottom: 0.5rem;
	margin-bottom: 1rem;
	h5 {
		@include fluid(font-size, 1.125rem, 1.5rem);
		font-family: $fontFamilyBase;
		font-weight: 700;
		flex: 1 1 100%;
		margin-bottom: 1rem;
	}
	&__inner {
		display: grid;
		grid-template-rows: auto auto auto;
		grid-template-columns: 1fr 1fr 1fr minmax(min-content, 130px);
		gap: 0.75rem 0;

		&::before {
			content: '';
			grid-area: span 1 / span 1;
			order: 2;
			
		}
		&::after {
			content: '';
			grid-area: span 1 / span 3;
			order: 5;
		}

		@include mqdn(md) {
			display: flex;
			flex-direction: column;
			gap: 1rem;
			&::before,
			&::after {
				display: none;
			}
		}
	}
	&__dropdowns.blue-form {
		display: contents;
		// display: flex;
		// flex: 1 1 calc(100% - 190px);
		// @include mqdn(md) {
		// 	flex-direction: column;
		// }
		@include mqdn(md) {
			display: flex;
			flex-direction: column;
			gap: 1rem;
		}
	}
	&__filter {
		display: contents;
		// flex: 1 1 33.33%;
		// @include mqdn(md) {
		// 	&:not(:first-child) {
		// 		margin-top: 1.25rem;
		// 	}
		// }
		@include mqdn(md) {
			display: flex;
			flex-direction: column;
			gap: 0.25rem;
		}
		@include mq(md) {
			&:not(:last-child) {
				.filters__select-custom select {
					border-right: none;
				}
			}
		}
	}
	&__label {
		grid-area: span 1 / span 1;
		order: 1;
		margin: 0;
	}
	&__select-custom {
		display: flex;
		grid-area: span 1 / span 1;
		order: 3;
		position: relative;
		&::before {
			@include icon;
			content: "\e903";
			font-size: 0.75rem;
			position: absolute;
			top: 50%;
			transform: translateY(-50%);
			right: 1rem;
			z-index: -1; 
		}
		&.empty {
			&::after {
				content: attr(title);
				position: absolute;
				left: 1.25rem;
				top: 50%;
				transform: translateY(-50%);
				color: #5f6e7d;
				z-index: -1;
			}
		}
	}
	select:not([type=checkbox]):not([type=radio]) {
		margin-bottom: 0;
		border-color: #606E7C;
		&:active,
		&:focus {
			border: 1px solid;
			box-shadow: 0 0 0 2px $blue;
		}
	}
	&__controls {
		display: contents;
		@include mqdn(md) {
			display: flex;
			align-items: center;
			justify-content: space-between;
			gap: 1rem;
		}
		// flex: 0 0 140px;
		// display: flex;
		// flex-direction: column;
		// margin-top: 20px;
		// margin-left: 2rem;
		// @include mqdn(md) {
		// 	margin-left: 0;
		// 	flex-direction: row;
		// 	align-items: baseline;
		// 	max-height: 80px;
		// }
	}
	&__apply {
		grid-area: span 1 / span 1;
		order: 4;
		align-self: center;
		display: block;
		// margin-bottom: 0.75rem;
		padding: 0.75rem 1.5rem;
		margin-left: 1rem;
		cursor: pointer;
		@include mqdn(md) {
			margin-left: 0;
			flex: 0 0 auto;
		}
	}
	&__clear {
		grid-area: span 1 / span 1;
		justify-self: start;
		order: 6;
		text-align: left;
		padding: 2px;
		border: none;
		margin: 0;
		margin-left: 1rem;
		background: transparent;
		font-weight: 700;
		color: $darkGray;
		@include linkHover;
		cursor: pointer;
		position: relative;
		&::after {
			@include icon;
			content: "\e907";
			position: absolute;
			right: -1rem;
			font-size: 0.625rem;
			top: 50%;
			transform: translateY(-50%);
			color: $gray;
		}
		@include mqdn(md) {
			margin: 0 auto;
			flex: 0 0 auto;;
		}
	}
}
</style>
